import { useContext } from 'react'
import { MkAccountContext, MkAccountContextType } from './_context'

export const useAccountContext = (): MkAccountContextType => {
  const context = useContext(MkAccountContext)
  if (context === undefined) {
    throw new Error('useAccountContext must be used within a MkAccountProvider')
  }
  return context
}
